import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import "./ForgotPassword.css";

const PasswordReset = () => {
  const location = useLocation(); // ✅ get current URL location
  const navigate = useNavigate();

  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token"); // ✅ get 'token' from query

  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!token) {
      setMessage("Invalid or missing token.");
      return;
    }

    try {
      const res = await axios.post(
        "https://bookmatchup.onrender.com/api/auth/reset-password",
        {
          token,
          password,
        }
      );

      setMessage(res.data.message || "Password reset successful!");
      setSuccess(true);
    } catch (err) {
      console.error(err);
      setMessage(err.response?.data?.message || "Failed to reset password.");
    }
  };

  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        navigate("/login");
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [success, navigate]);

  return (
    <div className="auth-page">
      <h2>Reset Your Password</h2>
      <form onSubmit={handleSubmit} className="auth-form">
        <input
          type="password"
          placeholder="New Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button type="submit" className="auth-button">
          Reset Password
        </button>
      </form>

      {message && (
        <p
          className={`message ${success ? "success-message" : "error-message"}`}
        >
          {message}
        </p>
      )}
    </div>
  );
};

export default PasswordReset;
